$(document).ready(function () {

  initModuleSlider();
  preProductConfiguratorVars();
  scrollToConfigurator();
  initCollectionGridSlider();

  var resizeId;
  $(window).resize(function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 500);
  });

  function doneResizing() {
    if (window.innerWidth < 767) {
      if (!$('.testimonials__blocks').hasClass('slick-initialized')) {
        initTestimonialsSlider();
      }
      if (!$('.collectionGrid-row, .collection-products__list').hasClass('slick-initialized')) {
        initCollectionGridSlider();
      }
    } else {
      if ($('.testimonials__blocks').hasClass('slick-initialized')) {
        $('.testimonials__blocks').slick('unslick');
      }
      if ($('.collectionGrid-row, .collection-products__list').hasClass('slick-initialized')) {
        $('.collectionGrid-row, .collection-products__list').slick('unslick');
      }
    }
  }

  //onScroll events
  $.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  $(window).scroll(function () {
    var productVideo = document.getElementById("product-video__video");
    // if (productVideo) {
    //   if ($(productVideo).isInViewport()) {
    //     productVideo.play();
    //   }else{
    //     productVideo.muted = true;
    //     productVideo.pause();
    //   }
    // }
  });

  function scrollToConfigurator() {
    if ($('#productConfiguratorIFrame').length) {
      $('html, body').animate({
        scrollTop: $("#productConfiguratorIFrame").offset().top - (window.innerWidth < 767 ? 75 : 60)
      }, 1000);
    }
  }

  function preProductConfiguratorVars() {
    var productConfiguratorVars = $('.product-form').data('configurator-url-vars');
    $('.product-configurator-trigger__link').attr('href', $('.product-configurator-trigger__link').attr('href') + productConfiguratorVars);
    $('.configurator-presets-trigger__link').attr('href', document.referrer);
  }

  function initTestimonialsSlider() {
    if (window.innerWidth < 767) {
      $('.testimonials__blocks').slick({
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false
            }
          }
        ]
      });
    }
  }

  initTestimonialsSlider();

  function initCollectionGridSlider() {
    if (window.innerWidth < 767 && !$('.collectionGrid-row').hasClass('grid--shop-accessories')) {
      $('.collectionGrid-row, .collection-products__list').slick({
        responsive: [
          {
            breakpoint: 767,
            lazyLoad: 'progressive',
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          },
          {
            breakpoint: 480,
            lazyLoad: 'progressive',
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              lazyload: true
            }
          }
        ]
      });
    }
  }

  initCollectionGridSlider();

  //product page module carousel
  function initModuleSlider() {
    $('.modules-slider').on('ready.flickity', function () {
      setTimeout(function () {
        var index = $('.modules-slider').find('.item.active').index();
        $('.modules-slider').flickity('selectCell', index);
      }, 1000);
    });

    $('.modules-slider').flickity({
      cellAlign: 'center',
      freeScroll: true,
      wrapAround: false,
      contain: true,
      groupCells: true,
      pageDots: false
    });

    // $('.modules-slider').flickity({
    //   cellAlign: 'center',
    //   freeScroll: false,
    //   wrapAround: false,
    //   contain: false,
    //   groupCells: 2,
    //   pageDots: false
    // });
  }


  //product page variants slider ( mobile )
  function initVariantsSlider() {
    if (window.innerWidth < 1000) {
      /*            $('.product-materials--slider').on('ready.flickity', function () {
                    setTimeout(function () {
                        var index = $('.product-materials--slider').find('.item.active').index();
                        $('.product-materials--slider').flickity('selectCell', index);
                    }, 1000);
                });
                $('.product-materials--slider').flickity({
                    cellAlign: 'left',
                    freeScroll: false,
                    contain: true,
                    groupCells: false,
                    pageDots: false,
                    prevNextButtons: false
                });*/

      /*          $('.product-colors--slider').on('ready.flickity', function () {
                    setTimeout(function () {
                        var index = $('.product-colors--slider').find('.item.active').index();
                        $('.product-colors--slider').flickity('selectCell', index);
                    }, 1000);
                });
                $('.product-colors--slider').flickity({
                    cellAlign: 'left',
                    freeScroll: true,
                    contain: true,
                    groupCells: true,
                    pageDots: false,
                    prevNextButtons: false
                });*/
    }
  }

  initVariantsSlider();

  //collection images sliders
  $('.col__images-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style=""><svg width="20px" height="34px" viewBox="0 0 20 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="05_VETSAK_PRODUCT_PAGE_icons" transform="translate(-35.000000, -220.000000)" fill="#000000" fill-rule="nonzero"> <g id="Group-14" transform="translate(35.000000, 220.000000)"> <g id="DownArrow_light" transform="translate(10.000000, 17.000000) scale(-1, 1) rotate(-90.000000) translate(-10.000000, -17.000000) translate(-6.500000, 7.500000)"> <polygon id="Path" points="16.5 18.5 16.5 18.5 0.5 2.75 0.5 0.5 2.78571429 0.5 16.5 14 30.2142857 0.5 32.5 0.5 32.5 2.75"></polygon> </g> </g> </g> </g> </svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="20px" height="34px" viewBox="0 0 20 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="05_VETSAK_PRODUCT_PAGE_icons" transform="translate(-1866.000000, -221.000000)" fill="#000000" fill-rule="nonzero"> <g id="Group-14" transform="translate(35.000000, 220.000000)"> <g id="DownArrow_light" transform="translate(1841.000000, 17.500000) rotate(-90.000000) translate(-1841.000000, -17.500000) translate(1825.000000, 8.000000)"> <polygon id="Path" points="16 18.2857143 16 18.2857143 0 2.28571429 0 0 2.28571429 0 16 13.7142857 29.7142857 0 32 0 32 2.28571429"></polygon> </g> </g> </g> </g> </svg></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      }
    ]
  });

  //video handlers
  //var homeHeaderVid = document.getElementById("home-header__video");
  $('.icon--play-small').click(function () {
    var productVideo = document.getElementById("product-video__video");
    if (productVideo) {
      productVideo.muted = true;
    }
    $(this).parent().siblings('video').get(0).play();
  });
  $('.icon--pause-small').click(function () {
    $(this).parent().siblings('video').get(0).pause();
  });

  //click handlers
  $('.trigger').click(function () {
    if ($(this).parent().hasClass('active')) {
      $(this).parent().removeClass('active');
    } else {
      $(this).parent().addClass('active');
    }
  });

  $('.arrow--slide-up').click(function (e) {
    $('html, body').animate({
      scrollTop: $("body").offset().top - 1
    }, 1000);
  });

  $('.box__link--shop-beanbags').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#shopify-section-collection-template").offset().top - 1
    }, 1000);
  });

  $('.box__link--shop-accessories').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $(".collection-products").offset().top - 1
    }, 1000);
  });

  $('.product-tabs__nav-item').click(function () {
    $('.product-tabs__nav-item').removeClass('active');
    $(this).addClass('active');
    var productTabIndex = $(this).index();
    $('.product-tabs__row').removeClass('active');
    $('.product-tabs__row').eq(productTabIndex).addClass('active');
  });

  $('.product-layout-images__full-screen').click(function (e) {
    $('.product-image.is-selected').find('.product-image__lightbox-link').trigger('click');
  });

  //cookies bar
  function setCookie(key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (360 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
  }

  function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
  }

  function delete_cookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  var cookie_val = getCookie('cookies-msg');
  if (cookie_val !== 'cookies-bar-fired') {
    $('.cookies-permission').addClass('active');
  }

  $('.cookies-permission__button').click(function () {
    $('.cookies-permission').removeClass('active');
    setCookie('cookies-msg', 'cookies-bar-fired');
  });

  //Fabric Samples form
  $(".samples-form__submit").click(function (e) {
    e.preventDefault();
    $('.form-item--required-text').removeClass('required--success');
    //$(".kontakt-form__submit").prop('disabled',true);

    var emailaddressVal = $(".contactFormEmail").val();
    var inputsVal = $(".form-field--required > input").val();

    if (emailaddressVal == '' || emailaddressVal.indexOf('@') === -1 || emailaddressVal.indexOf('.') === -1) {
      e.preventDefault();
      $('.form-item--required-text').addClass('required--error');
      $('.form-item--required-text > p').empty().append('Please fill all the required fields');
      return false;
    }

    if (inputsVal == '') {
      e.preventDefault();
      $('.form-item--required-text').addClass('required--error');
      $('.form-item--required-text > p').empty().append('Please fill all the required fields');
      return false;
    }

    if ($('.form-item--checkbox > input').is(':checked') == false) {
      e.preventDefault();
      $('.form-item--required-text').addClass('required--error');
      $('.form-item--required-text > p').empty().append('Please accept data protection regulations');
      return false;
    }
    ;

    $('.form-item--required-text').removeClass('required--error').addClass('required--success');
    $('.form-item--required-text > p').empty().append('Thank you! We will reach out to you soon.');

    $(this).closest('form').submit();

  });

  //fabric samples quantity
  $('.item__checkbox--sample').prop('checked', false);
  $('.item__checkbox--sample').change(function () {
    var samplesCounter = 0;
    var samplesList = [];
    $('.item__checkbox--sample:checked').each(function () {
      samplesList.push($(this).val());
      samplesCounter++;
      $('.choosen-samples').empty().html(samplesCounter);
    });
    $('#Form-samples-list').val(samplesList);
  });

  //change 404 button link to previous page
  // if (document.referrer.indexOf(location.host) === -1) {
  //   $('#404-link').attr('href', document.referrer);
  // }

  // lang switcher
  $('.js-lang-select-old').change(function () {
    var selectedLang = $('.js-lang-select-old :selected').data('url');
    window.location.replace(selectedLang);
  });


  $('.js-lang-select').change(function () {
    var selectedLang = $('.js-lang-select :selected').data('url');
    window.location.replace(selectedLang);
  });

  //Group cart items
  window.groupCart = function () {
    const $children = $(".cart-table-body").children(".line-item");
    let compositions = $children.map(function () {
      return this.dataset.composition;
    });
    compositions = $.unique(compositions.get());

    $.each(compositions, function (i, composition) {
      let total = $('[data-composition="' + composition + '"]');
      let compositionPhoto = "";
      let compositionPhotoImg = $('[data-composition="' + composition + '"]').eq(total.length - 1).data('photo');
      if (compositionPhotoImg) {
        if (compositionPhotoImg.includes('cdn.shopify.com')) {
          compositionPhoto = '<img src="' + compositionPhotoImg + '"/>';
        } else {
          compositionPhoto = '<img src="data:image/png;base64, ' + compositionPhotoImg + '"/>';
        }
      }
      $('[data-composition="' + composition + '"]').eq(0).before('<div class="cart-table-title"><div><div class="cart-table-title__wrapper">' + compositionPhoto + '<span>' + composition + '</span></div></div><div></div><div></div><div></div></div>');
    });
  };
  groupCart();

  // get Jobs page onapply script
  $.getScript("https://cdn.shopify.com/s/files/1/0411/9917/3789/t/3/assets/onapplyCareerSite.js", function (data, textStatus, jqxhr) {
    console.log("onapply script loaded");
  });

  function updateSelectedSamplesCount() {
    $('.js-selected-samples').text($('[data-variant].selected').length)
  }

  function verifySelectedSamplesCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json()
      })
      .then(function (cart) {
        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            if (document.querySelector('[data-variant="' + item.variant_id + '"]')) {
              document.querySelector('[data-variant="' + item.variant_id + '"]').classList.add('selected')
              document.querySelector('[data-variant="' + item.variant_id + '"]').classList.add('disabled')
            }
          })
        }
      })
  }

  if ($('.js-selected-samples').length) {
    $('.js-selected-samples').text($('[data-variant].selected').length)

    verifySelectedSamplesCount()
  }

  // fabric samples page
  $('[data-variant]:not(.disabled)').each(function (index, variantSelector) {
    $(variantSelector).on('click', function (e) {
      e.preventDefault();

      if ($(variantSelector).hasClass('disabled')) {
        return;
      }

      const currentlySelectedItemsCount = $('[data-variant].selected').length;


      if (currentlySelectedItemsCount > 7 && !$(variantSelector).hasClass('selected')) {
        $('.size-warning-popup--wrapper').fadeIn();
      } else {
        $(variantSelector).toggleClass('selected');
      }

      $('.js-selected-samples').text($('[data-variant].selected').length)
      verifySelectedSamplesCount()
    });
  });

  $('.js-quantity-warning-confirm').on('click', function () {
    $('.size-warning-popup--wrapper').fadeOut();
  });

  $('.js-fabric-productForm-submit').on('click', function (e) {
    e.preventDefault();
    const items = [];


    $('[data-variant].selected:not(.disabled)').each(function (index, variantSelector) {
      items.push({ "id": $(variantSelector).attr('data-variant'), "quantity": 1 })
    });

    if (items.length) {
      $(this).attr("disabled", true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ "items": items })
      }).then(function () {
        window.location = '/cart'
      })

    }

  });


  //product size warning handles

  if ($('[data-size-warning-toggle]').length) {
    const popupContainer = $('.size-warning-popup--wrapper');
    const addToCartButton = $('[data-size-warning-toggle]');
    addToCartButton.on('click', function (e) {
      e.preventDefault();
      popupContainer.fadeIn();
    });

    $('.js-size-warning-cancel').on('click', function (e) {
      popupContainer.fadeOut();
    });

    $('.js-size-warning-confirm').on('click', function (e) {
      e.preventDefault();
      addToCartButton.closest('form').submit();
    });

    popupContainer.on('click', function (e) {
      if (e.currentTarget === e.target) {
        popupContainer.fadeOut();
      }
    });
  }

  if ($('#ProductBundleData').length) {
    const addToCartButton = $('.js-productForm-submit');
    addToCartButton.on('click', function (e) {
      e.preventDefault();
      const variantsData = JSON.parse(document.querySelector('#ProductBundleData').innerHTML);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(variantsData)
      }).then(function () {
        if (document.querySelector(".upsell-wrapper")) {
          document.querySelector(".upsell-wrapper").setAttribute('data-active', 'true')
          if ($('.upsell-products').flickity) {
            $('.upsell-products').flickity('resize')
          }
        } else {
          window.location = '/cart'
        }
      })
    });
  } else if ($('.productForm [name="id"]') && document.querySelector(".upsell-wrapper")) {
    const addToCartButton = $('.js-productForm-submit');
    addToCartButton.on('click', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: $('.productForm [name="id"]').val(),
            quantity: 1
          }]
        })
      }).then(function () {
        if (document.querySelector(".upsell-wrapper")) {
          document.querySelector(".upsell-wrapper").setAttribute('data-active', 'true')
          if ($('.upsell-products').flickity) {
            $('.upsell-products').flickity('resize')
          }
        } else {
          window.location = '/cart'
        }
      })
    });
  }

  // cart upsell
  if ($('.upsell-product').length) {
    $('.upsell-wrapper').addClass('active')

    if ($('.upsell-product').length > 2) {
      $('.upsell-products').flickity({
        cellAlign: 'center',
        wrapAround: false,
        imagesLoaded: true,
        contain: true,
        groupCells: true,
        pageDots: false,
        adaptiveHeight: true
      });
    }

    $('.upsell-wrapper').on('click', function (evt) {
      if (evt.target.classList.contains('upsell-wrapper')) {
        if (evt.target.getAttribute('data-product-page') === 'true') {
          window.location = '/cart'
        } else {
          $('.upsell-wrapper').removeClass('active')
        }
      }
    })

    $('.js-close-upsell').on('click', function (evt) {
      if ($('.js-close-upsell').attr('data-product-page') === 'true') {
        window.location = '/cart'
      } else {
        $('.upsell-wrapper').removeClass('active')
      }
    })

    $('.js-upsell-add-all-products').on('click', function () {
      const button = $(this)

      const items = button.attr('data-ids').split(',').filter(function (variant_id) {
        return !!variant_id
      }).map(function (variant_id) {
        return ({
          id: variant_id,
          quantity: 1
        })
      })

      if (items.length) {
        $(this).attr("disabled", true);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ "items": items })
        }).then(function () {
          window.location = '/cart'
        })
      }
    })

    $('.upsell-product button').on('click', function () {
      const button = $(this)
      const variant_id = button.attr('data-id')

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          quantity: 1,
          id: variant_id
        })
      }).then(function () {
        Cart.getCart(Cart.buildCart);

        $(button.closest('.upsell-product')).addClass('added')

        if ($('.upsell-product').length === $('.upsell-product.added').length) {
          $('.upsell-wrapper').removeClass('active')
          window.location = '/cart'
        }
      })
    })
  }
  //slider with image
  $('.image-part-wrapper').each(function () {
    new Flickity(this, {
      // options
      cellAlign: 'left',
      contain: true
    })
  })

  $('body').on('click', '.filtered-collection-button', function () {
    const button = $(this)
    const variant_id = button.attr('data-id')
    button.addClass('loading')
    button.removeClass('added')

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        id: variant_id
      })
    }).then(function () {
      Cart.getCart(Cart.buildCart);

      button.removeClass('loading')
      button.addClass('added')

      setTimeout(() => {
        button.removeClass('added')
      }, 1500)
    })
  })

  const updateNoteCart = (cart_note) => {
    const note = cart_note

    $.ajax({
      type: 'POST',
      url: '/cart/update.json',
      data: {
        note: note
      },
      dataType: 'application/json'
    })
  }

  const checkNote = (textarea) => {
    const cart_note = (textarea.val() || '').toString()
    updateNoteCart(cart_note)
  }

  $('#order-notes').each((_, textarea) => {
    $(textarea).on('change', () => checkNote($(textarea)))
  })
});

